import * as React from "react";
import { Box, Grid, Typography } from "@mui/material";
import DefaultModal from "../DefaultModal";
import CircularProgress from "@mui/material/CircularProgress";

const ModalAtualizacaoBancoEmAndamento = ({ open, onClose }) => {
  return (
    <DefaultModal
      open={open}
      onClose={onClose}
      title=""
      hideCloseButton // se seu DefaultModal tiver suporte, remove o botão de fechar
      maxWidth="md"
      fullWidth
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          height: "60vh",
          textAlign: "center",
          background: "rgba(0, 0, 0, 0.02)",
          borderRadius: 2,
          p: 4,
        }}
      >
        <Grid container spacing={2} justifyContent="center" alignItems="center">
          <Grid item xs={12}>
<CircularProgress size={80} thickness={4} color="primary" />

          </Grid>
          <Grid item xs={12}>
            <Typography variant="h5" fontWeight="bold" sx={{ mb: 1 }}>
              Atualização em andamento...
            </Typography>
            <Typography variant="body1" sx={{ color: "text.secondary" }}>
              Aguarde enquanto os bancos estão sendo sincronizados.
              <br />
              Esse processo pode levar alguns minutos.
            </Typography>
          </Grid>
        </Grid>
      </Box>
    </DefaultModal>
  );
};

export default ModalAtualizacaoBancoEmAndamento;
